//@ts-ignore
// @ts-nocheck
import { getParent, types } from "mobx-state-tree";
import { TutorEducation, TutorSummaryInfo, TutorWorkHistory } from "./tutor";

const InterpretDataInfo = types
  .model("InterpreteDataInfo", {
    badges: types.optional(types.array(types.string), []),
    clientCountry: types.optional(types.string, ""),
    isSpecial: types.optional(types.boolean, false),
    earlyChildArray: types.optional(types.array(types.string), []),
    isMonthly: types.optional(types.boolean, false),
    relevantSubjects: types.optional(types.array(types.string), []),
    isCertificate: types.optional(types.boolean, false),
    cambridgePrep: types.optional(types.array(types.string), []),
    placementExams: types.optional(types.array(types.string), []),
    certificateExams: types.optional(types.array(types.string), []),
    isPlacement: types.optional(types.boolean, false),
    isEarlyChild: types.optional(types.boolean, false),
    isEntrance: types.optional(types.boolean, false),
    isCambridge: types.optional(types.boolean, false),
    isPremium: types.optional(types.boolean, false),
    specialNeedExpertise: types.optional(types.array(types.string), []),
    tutorSummary: types.optional(types.array(TutorSummaryInfo), []),
    classGroup: types.optional(types.array(types.string), []),
    education: types.optional(types.array(TutorEducation), []),
    workHistory: types.optional(types.array(TutorWorkHistory), []),
  })
  .views((self) => {
    let parent = getParent(self, 1);
    return {
      get userId() {
        return parent.userId;
      },
      get testimonials() {
        let p = getParent(self, 1);
        return p.transformedTestimonials;
      },
      get featuredReview() {
        let p = getParent(self, 1);
        const orderTestimonials = () => {
          return [...this.testimonials].sort((a, b) => {
            let dateA = new Date(a.dateReviewed),
              dateB = new Date(b.dateReviewed);
            return dateB - dateA;
          });
        };
        let reviews = orderTestimonials();
        if (reviews.length < 2) return {};

        let fiveStarReviews = reviews
          .filter(({ rating }) => rating === 5)
          .sort((a, b) => b.review.length - a.review.length);

        let fourStarReviews = reviews
          .filter(({ rating }) => rating === 4)
          .sort((a, b) => b.review.length - a.review.length);

        let reviewPool = [
          ...fiveStarReviews.slice(0, 3),
          ...fourStarReviews.slice(0, 2),
        ];

        let orderedReviewPool = reviewPool.sort((a, b) => {
          let dateA = new Date(a.dateReviewed),
            dateB = new Date(b.dateReviewed);
          return dateB - dateA;
        });

        if (orderedReviewPool.length > 0) return orderedReviewPool[0];

        return {};
      },
    };
  });

export default InterpretDataInfo;
